<script lang="ts" setup>
import { computed } from '#imports';
import warnIcon from '~/assets/image/index/weekly-goods/icon-warning.svg';
const model = defineModel('open', { type: Boolean, default: false });
const props = defineProps<{
  type: string;
  title: string;
  content: string;
  okText: string;
  cancelText: string;
  onOk: () => void;
  onCancel: () => void;
  warning: boolean;
}>();

const eventData = computed(() => ({
  sub_type: props.type
}));
</script>
<template>
  <a-modal
    v-model:open="model"
    :centered="true"
    :closable="false"
    wrap-class-name=""
    :width="304"
    :footer="null"
    :mask-closable="false"
  >
    <div v-track:newoj_goodsbyweek_goproblem_show="eventData" class="p-1 pt-0 text-center">
      <h3 class="flex-center text-base font-bold text-font1">
        <img v-if="warning" class="mr-[2px] w-5" :src="warnIcon" alt="" />
        {{ title }}
      </h3>
      <p v-if="content" class="mt-6 text-font2">{{ content }}</p>
      <div class="flex-center mt-6 gap-6">
        <a-button class="min-w-[80px] !bg-[rgba(0,0,0,.06)] !text-[#4E5969]" type="primary" @click="onCancel">{{ cancelText }}</a-button>
        <a-button v-track:newoj_goodsbyweek_goproblem_click.click="eventData" class="min-w-[80px]" type="primary" @click="onOk">{{ okText }}</a-button>
      </div>
    </div>
  </a-modal>
</template>
